<template>
  <div class="dictionaries-fields-list">
    <div class="d-sm-flex justify-content-end">
      <pcg-btn variant="additional" v-b-modal.add-modal size="small"
               class="w-100 w-sm-auto m-0 font-weight-bold"
      >
        + {{ $t('general.new_type') }}
      </pcg-btn>
    </div>

    <dictionary-table
        :edit-resource="editResource"
        :destroy-resource="destroyResource"
        :items="items"
        resource-name="type"
        url="types"
    />

    <structure-modal
        :action="action(type, 'types')"
        :btn-title="btnTitle"
        :editMode="editMode"
        :errors="errors"
        :modalId="editMode ? 'edit-modal' : 'add-modal'"
        :title-modal="title"
        v-bind.sync="type"
        @hidden="hideModal('type')"
        @clear-error="errors[$event] = ''"
    />
  </div>
</template>

<script>
import DictionaryTable
  from '../../components/dictionaries/shared/DictionaryTable'
import StructureModal from '../../components/dictionaries/shared/StructureModal'
import useList from '../../composables/useList'
import useDictionary from '../../composables/useDictionary'
import { dictionary } from '../../mixins/dictionary'

export default {
  name: 'DictionaryTypes',
  setup (props, { root }) {
    const {
      items, setItems, removeRow, findItemById,
    } = useList(root)
    const {
      addResource,
      clearModel,
      destroyResource,
      editMode,
      editResource,
      errors,
      updateResource,
    } = useDictionary()
    return {
      addResource,
      clearModel,
      destroyResource,
      editMode,
      editResource,
      errors,
      findItemById,
      items,
      removeRow,
      setItems,
      updateResource,
    }
  },
  components: {
    DictionaryTable,
    StructureModal,
  },
  mixins: [dictionary],
  data () {
    return {
      type: {
        name: '',
        [Symbol.for('_innerName')]: 'type',
      },
    }
  },
  computed: {
    title () {
      if (this.editMode) {
        return this.$t('general.edit_type')
      } else {
        return this.$t('general.new_type')
      }
    },
    btnTitle () {
      if (this.editMode) {
        return this.$t('general.update')
      } else {
        return this.$t('general.add_type')
      }
    },
  },
  created () {
    this.getTypes()
  },
  methods: {
    async getTypes () {
      let { data: types } = await this.$api.get('types')
      types = types.map(type => {
        return {
          id: type.id,
          name: type.attributes.name,
        }
      })
      this.setItems(types)
    },

    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.header.dictionary.title'),
        subtitle: this.$tc('general.type', 2),
      })
    },
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  },
}
</script>
